import { drawerFooterStyle } from '@shared/style/modal';
import { Typography } from '../../../../../shared/ui/typography/typography';
import { styled } from 'goober';

export const Body = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const Footer = styled('div')`
    display: flex;
    width: 100%;
    gap: 12px;
    justify-content: flex-end;
    ${drawerFooterStyle}
`;

export const Subscription = styled(Typography)`
    margin-top: 10px;
`;
